import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function NotFoundPage() {
  const { lang } = useI18n();
  const c = lang === "en"
    ? { h: "Page not found.", p: "The page you're looking for doesn't exist or has moved. Go back to the home page.", cta: "Back to home" }
    : { h: "Pagina non trovata.", p: "La pagina che cerchi non esiste o è stata spostata. Torna alla home per orientarti.", cta: "Torna alla home" };
  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center" data-testid="not-found-page">
      <div className="text-xs uppercase tracking-editorial text-muted-ink mb-4">404</div>
      <h1 className="font-display text-6xl text-brand mb-4">{c.h}</h1>
      <p className="text-muted-ink mb-8">{c.p}</p>
      <Link to="/" className="inline-block rounded-full bg-brand text-white px-6 py-3 text-sm">{c.cta}</Link>
    </div>
  );
}
